import React from 'react';
import _ from 'lodash';

import Table from 'components/Table';
import Ellipsis from 'components/Ellipsis';
import Button from 'components/Button';

import {formatDate} from 'utils/datetime';

import deleteIcon from 'assets/icons/trash.svg';

import './styles.css';

const getDepartureValue = termination =>
  termination.terminatedBeforeMoveIn
    ? 'Terminated before move in'
    : formatDate(termination.departureDate);

const EarlyTerminationsTable = ({
  earlyTerminations,
  openTerminateTenancyModal,
  openDeleteEarlyTerminationModal
}) => {
  const isTenancyTerminated = earlyTerminations && earlyTerminations.length > 0;

  return (
    <div className="EarlyTerminationsTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem
            heading="Termination date"
            className="terminationDate"
          />
          <Table.HeaderItem
            heading="Early departure date"
            className="departureDate"
          />
          <Table.HeaderItem heading="Reason" className="reason" />
          <Table.HeaderItem heading="Created by" className="createdBy" />
          <Table.HeaderItem heading="Created" className="created" />
          <Table.HeaderItem heading="Notes" className="notes" />
          <Table.HeaderItem className="delete" />
        </Table.Header>
        <Table.Body>
          {!_.isEmpty(earlyTerminations) &&
            earlyTerminations.map(termination => {
              return (
                <Table.Row className="balances" key={termination.id}>
                  <Table.Cell className="terminationDate">
                    {formatDate(termination.terminationDate)}
                  </Table.Cell>
                  <Table.Cell className="departureDate">
                    {getDepartureValue(termination)}
                  </Table.Cell>
                  <Table.Cell className="reason">
                    {termination.reason.name}
                  </Table.Cell>
                  <Table.Cell className="createdBy">
                    {termination.createdBy.fullName}
                  </Table.Cell>
                  <Table.Cell className="created">
                    {formatDate(termination.createdAt)}
                  </Table.Cell>
                  <Table.Cell className="notes">
                    <Ellipsis>{termination.notes}</Ellipsis>
                  </Table.Cell>
                  <Table.Cell className="delete">
                    <img
                      src={deleteIcon}
                      alt="Delete"
                      onClick={() =>
                        openDeleteEarlyTerminationModal({
                          terminationId: termination.id
                        })
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
      <div className="tableFooter">
        {!isTenancyTerminated && (
          <Button blue onClick={openTerminateTenancyModal}>
            Terminate Early
          </Button>
        )}
      </div>
    </div>
  );
};

export default EarlyTerminationsTable;
